import Helper from "../Helper";
import Scrollbar from "../utils/Scrollbar";

/**
 * Represents autocomplete element that is part of search.
 */
export default class Autocomplete {

  /**
   * Constructor.
   *
   * @param {String} autocompleteName
   * @param {Search} context for search term preview update
   */
    constructor(autocompleteName, context)
    {
        this.context = context;
        this.autocompleteName = autocompleteName;
        this.autocomplete = $('[data-autocomplete="' + autocompleteName + '"]');
        this.wrapper = this.autocomplete.closest('[data-autocomplete-wrapper]');
        this.mainClear = this.wrapper.find('[data-clear]');
        this.lastData = [];
        this.searchTerm = this.autocomplete.val();
        this.placeholder = this.autocomplete.attr('placeholder');
        this.resultsAvailable = false;

      /**
       * Only for responsive logic
       */
        this.resultsScroll = undefined;
        this.iosKeyboardOpened = false;
        this.hideforever = false;

        if (this.autocomplete.length > 0) {
            this.init();
        }
    }

  /**
   * Initialise the autocomplete logic
   */
    init()
    {
        this.autocomplete.autocomplete({
            source: (request, response) => {
                $.ajax({
                    url: window.location.origin + '/search/location',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        term : request.term,
                        '_token': $('meta[name="csrf-token"]').attr('content'),
                    },
                    success: (data) => {
                        data.forEach((element) => {
                            this.lastData.push(element);
                        });

                    if (data.length === 0) {
                        this.autocomplete.addClass('error_input');
                        this.wrapper.addClass('error');

                        $('[data-search-submit="' + this.autocompleteName + '"]').prop('disabled', true);
                        $('html').bind('keypress', function (e) {
                            if (e.keyCode == 13) {
                                return false;
                            }
                        });
                    }
                    response(data);
                    }
                });
            },
            open: (event, ui) => {
                if (!this.resultsScroll) {
                    this.resultsScroll = new Scrollbar(this.wrapper.find('ul.ui-autocomplete').first());
                }
                let autocompleteResults = this.wrapper.find('.ui-autocomplete');
                this.autocomplete.removeClass('error_input');
                $('[data-search-submit="' + this.autocompleteName + '"]').prop('disabled', false);
                $('html').unbind('keypress');
                this.wrapper.removeClass('error');

                this.wrapper.find('[data-autocomplete-type="hotel"]').first().addClass('highlighted');
                this.wrapper.find('[data-autocomplete-type="location"]').first().addClass('highlighted');
                this.wrapper.find('[data-autocomplete-type="country"]').first().addClass('highlighted');

                let top = autocompleteResults.position().top + 10;

                // Position and alter results dimensions based on tablet, mobile or laptop
                if (Helper.isBigMobileOrLower()) {
                    autocompleteResults.css({
                        'width': this.wrapper.outerWidth() + 'px',
                        'top': (top + 14) + 'px',
                        'left': '0'
                    });

                    let windowHeight = $(window).height();
                    if (this.iosKeyboardOpened) {
                        if (Helper.isMobileLandscapeOriented()) {
                            windowHeight -= windowHeight * 0.6;
                        } else {
                            windowHeight -= windowHeight * 0.35;
                        }
                    }
                    this.resizeResultsToFitWindow(windowHeight);
                } else {
                    autocompleteResults.css({
                        'top': top + 'px',
                        'left': '-10px',
                    });
                }

                let wrapperMaxHeight = parseInt(autocompleteResults.css('max-height').split('px')[0]);
                let wrapperInnerHeight = 0;
                autocompleteResults.children().each(function () {
                    wrapperInnerHeight += $(this).outerHeight() });
            if (wrapperMaxHeight <= wrapperInnerHeight) {
                this.resultsScroll.enable();
            } else {
                this.resultsScroll.reset();
            }

            this.resultsAvailable = true;
            },
            change: (event, ui) => {
                if ($(event.target).is(':visible') && event.target.value != this.autocomplete.data('searchedTranslatableLocation') && event.target.value != window.searchText && ui.item !== undefined) {
                  // If the new value in input is different from stored translatable value, reset tranlatable options (user changed the input and not selected anything)
                  // and if also is different from lastly selected entity text
                    var sessions = {
                        'search_chosen_entity_type': null,
                        'search_chosen_entity_id': null,
                        'search_last_locale': null,
                        'search_tranlatable_location': null,
                        'location': event.target.value
                    };

                    window.setSessions(sessions);
                }
            },
            select: (event, ui) => {
                if (!(ui.item == null)) {
                    event.preventDefault();
                    event.stopPropagation();

                    var entityType = '';
                    var valueToInput = ui.item.value;
                    if (ui.item.type == 'hotel') {
                        valueToInput = valueToInput + ', ' + ui.item.location;
                        entityType = 'App\\Hotel';
                    } else if (ui.item.type == 'location') {
                        valueToInput = valueToInput + ', ' + ui.item.country_trans;
                        entityType = 'App\\Location';
                    } else if (ui.item.type == 'country') {
                        entityType = 'App\\Country';
                    }

                    window.searchText = valueToInput;

                    // Store the chosen entity to session for text translation
                    var sessions = {
                        'search_chosen_entity_type': entityType,
                        'search_chosen_entity_id': ui.item.id,
                        'search_last_locale': $('[name="country"]').attr('content'),
                        'search_tranlatable_location': valueToInput,
                        'location': valueToInput
                    };
                    window.setSessions(sessions);

                    this.autocomplete.val(valueToInput);
                    this.searchTerm = valueToInput;

                    this.resultsAvailable = false;
                    this.context.hideRespoModal();
                }
            },
            close: (event, ui) => {
                // If true, re-open the results
                if (Helper.isBigMobileOrLower() && !this.hideforever) {
                    let autocompleteResults = this.wrapper.find('.ui-autocomplete');
                    autocompleteResults.show();
                }

                this.hideforever = false;
            },
            highlight: false,
            minLength: 1,
            appendTo: '[data-search-term="' + this.autocompleteName + '"]'
        });

        // Handles adding of items to output list element
        this.autocomplete.autocomplete('instance')._renderItem = (ul, item) => {
            let newElement = '<div><div class="autocomplete__item" data-autocomplete-type="' + item.type + '">';
            newElement += '<div class="autocomplete__item__info">';
            newElement += '<div class="autocomplete__item__icon">';
            newElement += item.flaticon;
            newElement += '</div>';
            newElement += '<div class="autocomplete__item__info__main">';
            if (item.stars) {
                newElement += '<div class="stars">';
                for (let i = 0; i < item.stars; i++) {
                    newElement += this.autocomplete.data('flaticonStar');
                }
                newElement += '</div>';
            }
            newElement += '<h5 class="weight-medium m-0">' + item.value + '</h5>';
            if (item.location || item.country_trans) {
                newElement += '<p class="small m-0">' + ((item.location)? item.location : item.country_trans) + '</p>';
            } else {
                newElement += '<p class="small m-0">' + this.autocomplete.data('allLocationsTranslation') + '</p>'
            }
            newElement += '</div>';
            newElement += '</div>';
            if (item.review) {
                      newElement += '<div class="autocomplete__item__score">';
                      newElement += '<h4 class="weight-medium m-0">' + item.review + '</h4>';
                      newElement += '</div>';
            }
            newElement += '</div></div>';

            return $('<li>')
            .append(newElement)
            .appendTo(ul);
        };

      /**
       * Clearing autocomplete text
       */
        this.mainClear.click((e) => {
            e.preventDefault();
            this.autocomplete.val('');
            this.searchTerm = '';
            this.focusTheEnd();
            this.closeResults();
        });

      /**
       * Update context's preview on autocomplete text change
       */
        this.autocomplete.on('change', (event) => {
            this.searchTerm = $(event.target).val();
            this.context.updatePreview();
        });

      /**
       * Make autocomplete active and add document on click event, that will make autocomplete non-active
       */
        this.autocomplete.click((event) => {
            if (this.context.canToggleAction()) {
                event.stopPropagation();
                this.context.deactivateAllActions();
                this.wrapper.addClass('active');
            } else {
                event.preventDefault();
            }
        });

      /**
       * Registering observers
       */
        window.documentClickObserve.register(this.documentClickClosing.bind(this));
        window.windowResizeObserve.register(this.windowResizeCallback.bind(this));

        this.autocomplete.on('focus', (event) => {
            if (Helper.isBigMobileOrLower() && !this.context.isRespoModalOpened()) {
                event.preventDefault();
                return false;
            }

            this.autocomplete.attr('placeholder', '');

            if (Helper.isIOS()) {
                this.iosKeyboardOpened = true;
                this.disableBodyScrolling(); // Fixing Iphone body scrolling throught results scrolling

          // If keyboard opened and results are available resize them so that the scroll is working correctly
                if (this.resultsAvailable && Helper.isBigMobileOrLower()) {
                    let windowHeight = $(window).height();
                    if (this.iosKeyboardOpened) {
                        if (Helper.isMobileLandscapeOriented()) {
                              windowHeight -= windowHeight * 0.6;
                        } else {
                            windowHeight -= windowHeight * 0.35;
                        }
                    }
                    this.resizeResultsToFitWindow(windowHeight);
                }
            }
        });

        this.autocomplete.on('focusout', () => {
            this.autocomplete.attr('placeholder', this.placeholder);

            if (Helper.isIOS()) {
                this.iosKeyboardOpened = false;
                this.enableBodyScrolling(); // Fixing Iphone body scrolling throught results scrolling

                this.resizeResultsToFitWindow($(window).height());
            }

            // For "Done" button in Iphone keyboard
            if (this.context.isRespoModalOpened() && this.resultsAvailable) {
                this.wrapper.find('.ui-autocomplete').show();
                this.hideforever = false;
            }
        });

      /**
       * Opens search respo modal.
       */
        this.wrapper.click(() => {
            if (this.context.canToggleAction()) {
                this.activateAndFocus();
            } else {
                this.context.openRespoModal([this.wrapper], -1);

                // Ensures keyboard opening, the positioning hack prevents overscrolling the respo modal
                if (Helper.isIOS()) {
                    this.autocomplete.css({
                        'position': 'absolute',
                        'top': '-99999999px'
                    })
                    this.autocomplete.click();
                    this.autocomplete.css({
                        'position': '',
                        'top': ''
                    })
                }
            }
        });

        // For Iphone focus after respo open
        if (Helper.isIOS()) {
            this.autocomplete.get(0).setAttribute('autofocus', 'autofocus');
        }
    }

  /**
   * Returns current search term in autocomplete input.
   *
   * @returns {String}
   */
    getSearchterm()
    {
        return this.searchTerm;
    }

  /**
   * This function will close autocomplete results indifinetely.
   */
    closeResults()
    {
        this.hideforever = true;
        this.resultsAvailable = false;
        this.autocomplete.autocomplete('close');
    }

  /**
   * This function will resize results to fit window.
   * ! Use only with respo
   *
   * @param {Number} windowHeight
   */
    resizeResultsToFitWindow(windowHeight)
    {
        let autocompleteResults = this.wrapper.find('.ui-autocomplete');
        autocompleteResults.css({
          // 72 is offset from top of respo modal and 26 is padding bottom
            'max-height': windowHeight - (autocompleteResults.position().top + 72 + 26) + 'px',
            'width': this.wrapper.outerWidth() + 'px'
        });
    }

  /**
   * This function activates the autocomplete and sets focus to the end of a autocomplete input text.
   */
    activateAndFocus()
    {
        this.context.deactivateAllActions();
        this.autocomplete.click();
        this.focusTheEnd();
    }

  /**
   * This function focus to the end of a autocomplete input text.
   */
    focusTheEnd()
    {
        this.autocomplete.get(0).focus();
        let val = this.autocomplete.val();
        this.autocomplete.val('');
        this.autocomplete.val(val);
    }

  /**
   * Will trigger after window resize.
   *
   * @see WindowResizeSubject
   */
    windowResizeCallback()
    {
        if (Helper.isBigMobileOrLower() && this.wrapper.closest('[data-respo-modal]').length) {
            this.resizeResultsToFitWindow(window.innerHeight);
        } else if (Helper.isBigMobileOrLower()) {
            this.closeResults();
            this.autocomplete.blur();
            this.wrapper.removeClass('active');
        }

        if (Helper.isTabletOrHigher() && this.wrapper.closest('[data-respo-modal]').length) {
            this.closeResults();
            this.context.hideRespoModal();
        }
    }

  /**
   * Function that will be triggered after document click
   *
   * @see DocumentClickSubject
   *
   * @param {Element} $clickedElement jQuery element
   */
    documentClickClosing($clickedElement)
    {
        if (
        !$clickedElement.closest('[data-autocomplete-wrapper]').length
        && !$clickedElement.closest('[data-respo-modal]').length
        && !$clickedElement.closest('[data-dim]').length
        ) {
            this.wrapper.removeClass('active');
            setTimeout(() => {
                this.autocomplete.blur();
            });
            this.closeResults();

            if (!$clickedElement.closest('[data-search-submit]').length) {
                this.wrapper.removeClass('error');
            }
        } else if (
        (typeof $clickedElement.data('respo-modal') !== 'undefined' || $clickedElement.data('dim') == 'respo-' + this.autocompleteName)
        && this.resultsAvailable
        ) {
          // If clicked the respo modal, revive the results
            this.wrapper.find('.ui-autocomplete').show();
        }
    }

  // Iphone body scroll fix when scrolling results.

  /**
   * Prevents body scrolling.
   */
    stopBodyScroll()
    {
      // If the ios keyboard is opened, respo modal is not being dragged and results are visible
        if (this.iosKeyboardOpened && !this.context.respoModal.isBeingDragged() && this.resultsAvailable) {
            let top = 0;
          // On touch move scroll modal back to its initial position right after the move
            if (Helper.isBigMobileOrLower()) {
                top = this.context.respoModal.$modal.offset().top - this.context.respoModal.heightOffset;
            }
            $('html, body').stop().animate({
                scrollTop: top
            }, 500);
        }
    }

  /**
   * Disables body scrolling.
   */
    disableBodyScrolling()
    {
        document.addEventListener("touchmove", this.stopBodyScroll.bind(this));
    }

  /**
   * Enables back body scrolling.
   */
    enableBodyScrolling()
    {
        document.removeEventListener("touchmove", this.stopBodyScroll.bind(this));
    }
}
